import React from "react";
import { formatDecimal } from "../../../hooks/Method";

const ItemsAmountWidget = ({ item }) => {
  return (
    <>
      <div className="flex flex-col w-fit text-[14px]">
        <span className="border-b flex gap-1">
          Purchase Amount: $ {formatDecimal(item.totalPrice, true)}
        </span>

        <span className="font-bold">
          Total Return: $ {formatDecimal(item.returnAmt, true)}
        </span>
      </div>
    </>
  );
};

export default ItemsAmountWidget;
